import React, { createContext, useContext, useState, useEffect } from "react";
import { settingsAPI } from "../services/api";
import { getImageUrl } from "../utils/image";

const SettingsContext = createContext(null);

const defaults = {
  site_name: "Sava Fresh",
  site_tagline: "Trading FZE",
  site_description: "Premium global food trading company. Quality products, trusted sourcing, worldwide delivery.",
  site_favicon: "",
  whatsapp_number: "+971501234567",
  call_number: "+971501234567",
  email: "info@savafresh.com",
  address: "Sharjah Airport International Free Zone (SAIF Zone), UAE",
  footer_text: "Connecting the world's finest food producers with global markets.",
  social_facebook: "",
  social_instagram: "",
  social_linkedin: "",
  social_twitter: "",
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaults);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    settingsAPI.getAll()
      .then(({ data }) => {
        if (data.settings) setSettings({ ...defaults, ...data.settings });
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  useEffect(() => {
    if (settings.site_favicon) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href = getImageUrl(settings.site_favicon);
    }
  }, [settings.site_favicon]);

  const get = (key) => settings[key] || defaults[key] || "";

  return (
    <SettingsContext.Provider value={{ settings, get, loaded, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error("useSettings must be used within SettingsProvider");
  return ctx;
};
